import { Component, Input } from '@angular/core';

@Component({
  selector: 'ew-table-card-item',
  templateUrl: './table-card-item.component.html',
  styleUrls: ['./table-card-item.component.scss'],
})
export class TableCardItemComponent {
  @Input() img?: string;
  @Input() title?: string;
  @Input() classTitle?: string;
  @Input() subtitle?: string;
  @Input() rounded: 'md' | 'full' = 'full';
}
